import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Grid} from "..";
import {Exhibit} from "../../Exhibit";
import {Image} from "../../../../../src/components/Image";
import {fullWidth} from "timvir/core";
import image1 from "../../../../../assets/khachik-simonian-nXOB-wh4Oyc-unsplash.jpg";
import image2 from "../../../../../assets/frank-mckenna-4V8JxijgZ_c-unsplash.jpg";
import image3 from "../../../../../assets/jay-mantri-TFyi0QOx08c-unsplash.jpg";
import image4 from "../../../../../assets/jeremy-bishop-EwKXn5CapA4-unsplash.jpg";
import image5 from "../../../../../assets/lukasz-szmigiel-jFCViYFYcus-unsplash.jpg";
import image6 from "../../../../../assets/qingbao-meng-01_igFr7hd4-unsplash.jpg";
import image7 from "../../../../../assets/v2osk-1Z2niiBPg5A-unsplash.jpg";
function _createMdxContent(props) {
  const _components = {
    blockquote: "blockquote",
    code: "code",
    h1: "h1",
    h2: "h2",
    p: "p",
    pre: "pre",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Grid"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "CSS grid with a predefined template (columns, gaps etc)"
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        children: "<Grid>\n  <div>ITEM</div>\n  <div>ITEM</div>\n  <div>ITEM</div>\n  <div>ITEM</div>\n  <div>ITEM</div>\n</Grid>\n"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Basic"
    }), "\n", _jsxs(Grid, {
      children: [_jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Fullwidth"
    }), "\n", _jsxs(Grid, {
      className: fullWidth,
      children: [_jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      }), _jsx("div", {
        style: {
          height: 100,
          background: "rgba(0,0,0,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: "ITEM"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Combine ", _jsx(_components.code, {
        children: "<Grid>"
      }), " with the ", _jsx(_components.code, {
        children: "<Image>"
      }), " component."]
    }), "\n", _jsxs(Grid, {
      children: [_jsx(Image, {
        metadata: image1,
        img: {
          src: image1.src
        },
        sources: []
      }), _jsx(Image, {
        metadata: image2,
        img: {
          src: image2.src
        },
        sources: []
      }), _jsx(Image, {
        metadata: image3,
        img: {
          src: image3.src
        },
        sources: []
      }), _jsx(Image, {
        metadata: image4,
        img: {
          src: image4.src
        },
        sources: []
      }), _jsx(Image, {
        metadata: image5,
        img: {
          src: image5.src
        },
        sources: []
      }), _jsx(Image, {
        metadata: image6,
        img: {
          src: image6.src
        },
        sources: []
      }), _jsx(Image, {
        metadata: image7,
        img: {
          src: image7.src
        },
        sources: []
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Combine ", _jsx(_components.code, {
        children: "<Grid>"
      }), " with the ", _jsx(_components.code, {
        children: "<Exhibit>"
      }), " component."]
    }), "\n", _jsxs(Grid, {
      children: [_jsx(Exhibit, {
        children: _jsx("div", {
          style: {
            height: 100,
            background: "rgba(0,0,0,.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          children: "ITEM"
        })
      }), _jsx(Exhibit, {
        children: _jsx("div", {
          style: {
            height: 100,
            background: "rgba(0,0,0,.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          children: "ITEM"
        })
      }), _jsx(Exhibit, {
        children: _jsx("div", {
          style: {
            height: 100,
            background: "rgba(0,0,0,.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          children: "ITEM"
        })
      }), _jsx(Exhibit, {
        children: _jsx("div", {
          style: {
            height: 100,
            background: "rgba(0,0,0,.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          children: "ITEM"
        })
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
